// Shared SLA status display maps used by SlaTaskRow and SlaTaskDetailModal.
// Centralised here so both components stay in sync.

import { SlaStatus } from "./types";

export interface StatusBadge {
  label: string;
  className: string;
}

/** Badge variant used in the task-list row (border + light background). */
export const STATUS_BADGE: Record<SlaStatus, StatusBadge> = {
  on_time: { label: "On Time", className: "bg-primary text-white border border-primary" },
  // "upcoming" = open task within target_days, not yet at risk (api-contract D0.2)
  upcoming: { label: "Upcoming", className: "bg-primary text-white border border-primary" },
  at_risk: { label: "At Risk", className: "bg-warning-light text-white border border-warning" },
  breached: { label: "Breached", className: "bg-error-light text-white border border-error" },
  // "ahead" = completed task closed before its due date (api-contract D0.4)
  ahead: { label: "Ahead", className: "bg-primary text-white border border-primary" },
  no_sla: { label: "No SLA", className: "bg-black-10 text-black-60 border border-black-20" },
  // fallback only — API no longer emits "closed" for SLA endpoints (see api-contract §3)
  closed: { label: "Closed", className: "bg-black-10 text-black-60 border border-black-20" },
};

/** Inline-pill colour class used in the task-detail modal. */
export const STATUS_COLORS: Record<SlaStatus, string> = {
  on_time: "text-white bg-primary",
  upcoming: "text-white bg-primary",
  at_risk: "text-white bg-warning-light",
  breached: "text-white bg-error-light",
  ahead: "text-white bg-primary",
  no_sla: "text-black-60 bg-black-10",
  // fallback only — API no longer emits "closed" for SLA endpoints (see api-contract §3)
  closed: "text-black-60 bg-black-10",
};

/** Human-readable label for a status enum value (replaces all underscores). */
export function slaStatusLabel(status: SlaStatus | string | undefined): string {
  if (!status) return "";
  return status.replace(/_/g, " ");
}
